module.exports = __webpack_public_path__ + "assets/756af8e5560d200e53b52b1ff70f2ad0.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-vietnamese-400-normal.woff2
// module id = 2643
// module chunks = 121